import React, { useEffect, useState } from "react";
import { TextField, Button } from "@mui/material";
import * as _ from 'lodash'

const ManagerInfo = (props) => {

  const [isEdit, setIsEdit] = useState(false)
  const [data, setData] = useState({})
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const [address, setAddress] = useState('')

  const onSubmit = () => {
    if (!_.isEmpty(name) && !_.isEmpty(phone) && !_.isEmpty(address)) {
      setData({name, phone, address})
    }
    setIsEdit(false)
  }

  const onCancel = () => {
    setName(_.get(data, 'name', ''))
    setPhone(_.get(data, 'phone', ''))
    setAddress(_.get(data, 'address', ''))
    setIsEdit(false)
  }

  const isButtonEnabled = () => {
    return _.isEmpty(name) || _.isEmpty(phone) || _.isEmpty(address)
  }

  useEffect(() => {
    if (_.isEmpty(data)) return
    setName(_.get(data, 'name', ''))
    setPhone(_.get(data, 'phone', ''))
    setAddress(_.get(data, 'address', ''))
  }, [data])

  return (
    <div className="bordered bg-light p-4 mt-4">
      <div className="d-flex justify-content-between">
        <span className="font-size-20 font-weight-bold ps-3">
          Менежерийн мэдээлэл
        </span>
        {
          !isEdit ? <button className="fab-btn" onClick={() => setIsEdit(true)}>
            <img alt="edit" src="/images/edit.svg" height={16}/>
          </button> : <div className="d-flex">
            <button className="fab-btn" onClick={onCancel}>
              <img alt="close" src="/images/close.svg" height={11}/>
            </button>
            <button disabled={isButtonEnabled()} className="fab-btn bg-primary border-none me-2" onClick={onSubmit}>
              <img alt="btn" src={isButtonEnabled() ? "/images/check.svg" : "/images/check_white.svg"} height={13}/>
            </button>
          </div>
        }
      </div>
      {!_.isEmpty(data) || isEdit ? 
        <>
          {
            isEdit ? 
              <TextField 
                className="mt-4 mb-2 w-100" 
                label="Нэр" 
                variant="outlined"
                value={name}
                onChange={(e) => setName(e.target.value)}
              /> : 
              <div className="mt-4">
                <div className="font-size-12 text-grey">НЭР</div>
                <div className="font-size-16">{name}</div>
              </div>
          }
          {
            isEdit ? 
              <TextField 
                className="mt-3 mb-2 w-100" 
                label="Утасны дугаар" 
                variant="outlined"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              /> : 
              <div className="mt-3">
                <div className="font-size-12 text-grey">УТАСНЫ ДУГААР</div>
                <div className="font-size-16">{phone}</div>
              </div>
          }
          {
            isEdit ? 
              <TextField 
                className="mt-3 mb-2 w-100" 
                label="Хаяг" 
                variant="outlined"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              /> : 
              <div className="mt-3">
                <div className="font-size-12 text-grey">ХАЯГ</div>
                <div className="font-size-16">{address}</div>
              </div>
          }
        </> : 
        <div className="dotted-container mt-4">
          <img alt="add" src="/images/add_rounded.svg" height={27}/>
          <div className="text-grey font-size-12 text-center font-weight-500 mt-2">
            Уг хэсэгт мэдээлэл байхгүй байгаа <br />
            тул мэдээлэл оруулж өгнө үү
          </div>
          <Button 
            onClick={() => setIsEdit(true)}
            className="bg-primary btn-bordered mt-4 px-4" 
            variant="contained" 
            disableElevation>
            Мэдээлэл оруулах
          </Button>
        </div>
      }
    </div>
  );
};

export default ManagerInfo;
